export default "https://legacy.eskolare-development.com/images/heroimage-welcome.png";